import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const FriendNotificationModule = {
  namespaced: true,
  state: {
    existingCustomerMsisdn: '',
    disableReferFriend: false,
    captcha: {
      code: '',
      token: ''
    }
  },
  getters: {
    existingCustomerMsisdn: (state) => {
      return state.existingCustomerMsisdn
    },
    disableReferFriend: (state) => {
      return state.disableReferFriend
    },
    referFriend: (state, getters) => {
      const referFriend = {
        existingCustomerMsisdn: getters.existingCustomerMsisdn
      }
      return getters.existingCustomerMsisdn === '' ? null : referFriend
    },
    captcha: (state) => {
      console.log('Test store captcha')
      return state.captcha
    }
  },
  mutations: {
    existingCustomerMsisdn: (state, existingCustomerMsisdn) => {
      state.existingCustomerMsisdn = existingCustomerMsisdn
    },
    disableReferFriend: (state, disableReferFriend) => {
      state.disableReferFriend = disableReferFriend
    },
    captcha: (state, { code, token }) => {
      state.captcha = { code, token }
    }
  },
  actions: {
    async checkReferFriend ({ commit, state, rootGetters }, { existingCustomerMsisdn, newCustomerMsisdn, processName, captcha }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query ${processName} ($referFriendInput: ReferFriendInput!) {
          checkReferFriend(referFriend: $referFriendInput) {
            success
          }
        }`,
        variables: {
          referFriendInput: {
            brand: rootGetters.brand,
            ...existingCustomerMsisdn ? { existingCustomerMsisdn: existingCustomerMsisdn } : [],
            ...newCustomerMsisdn ? { newCustomerMsisdn: newCustomerMsisdn } : [],
            ...captcha ? { captcha: captcha } : []
          }
        }
      }).then((response) => {
        if (response.data.checkReferFriend.success) {
          commit('existingCustomerMsisdn', existingCustomerMsisdn)
          commit('captcha', captcha)
          commit('disableReferFriend', false)
        }
        return response.data.checkReferFriend
      }).catch((error) => {
        commit('disableReferFriend', true)
        return splitError(error)[0].message
      })
    },
    async referFriendSelfCare ({ commit, state, rootGetters }, { newCustomerMsisdn }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation friendNotification ($referFriendInput: ReferFriendInput!) {
          referFriendSelfCare (referFriend: $referFriendInput) {
            success
          }
        }`,
        variables: {
          referFriendInput: {
            brand: rootGetters.brand,
            newCustomerMsisdn: newCustomerMsisdn,
            captcha: state.captcha
          }
        }
      }).then((response) => {
        commit('addMessage', {
          type: 'success',
          message: 'Ihre Freundschaftswerbung war erfolgreich! Innerhalb der nächsten 3 Tage erhalten Sie und Ihr Freund jeweils 5 Euro Guthaben. Sie haben die Möglichkeit in 30 Tagen einen weiteren Freund zu werben!'
        }, { root: true })
        return response.data.referFriendSelfCare
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  }
}

export {
  FriendNotificationModule
}
